import { IconPlaceholder } from '@juvare/common-web-ui/IconPlaceholder';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../hooks';
export const Slots = ({ total, totalApproved }) => {
    const { t } = useMissionsTranslation();
    const completed = total ? (totalApproved / total) * 100 : 0;
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1, width: '100%' }, "data-test": 'slots' },
        (total === 0 || total !== totalApproved) && (React.createElement(IconPlaceholder, { status: 'disabled' },
            React.createElement(SupervisorAccountOutlinedIcon, null))),
        total !== 0 && totalApproved === total && (React.createElement(IconPlaceholder, { status: 'success' },
            React.createElement(CheckCircleOutline, null))),
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                flexGrow: 1,
            } },
            React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey[700] } }, totalApproved < total ? t('slots.filled', { totalApproved, total }) : t('slots.allFilled')),
            React.createElement(LinearProgress, { "aria-label": t('shifts.ariaLabels.slotsFilledProgressBar'), variant: 'determinate', value: completed }))));
};
